import React from 'react';

import { Item, MerchantPricingBasket } from 'apis/restaurant-api/merchant-admin/purchases/types';

import PurchaseBreakdownItem from './PurchaseBreakdownItem';

type PurchaseBreakdownProps = {
  basket: MerchantPricingBasket;
  items: Item[];
};

const PurchaseBreakdown = ({ items, basket }: PurchaseBreakdownProps) => {
  return (
    <>
      {items.map(item => {
        const merchantPricingItem = basket.items.find(merchantItem => merchantItem.row_number === item.row_number);
        return merchantPricingItem ? (
          <PurchaseBreakdownItem item={item} merchantPricingItem={merchantPricingItem} key={item.id} />
        ) : null;
      })}
    </>
  );
};

export default PurchaseBreakdown;
